/**

 * Configurações centralizadas da aplicação Hivi

 * Valores obtidos das variáveis de ambiente

 */

export const APP_CONFIG = {
  // Informações da aplicação

  name: process.env.REACT_APP_NAME || 'Hivi',

  version: process.env.REACT_APP_VERSION || '1.0.0',

  /** Logo de marca (marketing, cadastro, header público). */
  brandLogoPath: '/logo_hivi.png',

  // Contatos de suporte

  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'contato@hivi.com.br',

  // URLs institucionais

  websiteUrl: process.env.REACT_APP_WEBSITE_URL || 'https://hivi.com.br',

  // Informações de copyright

  currentYear: new Date().getFullYear(),
} as const;
